import axios from "axios";
import axiosRetry from "axios-retry";
/*-- 2026.09.08 V2.2.1 AI ADD START チケット#14484 全API認証導入フェーズ1 --*/
import store from "../store";
import router from "../router";
/*-- 2026.09.08 V2.2.1 AI ADD END --*/

// API接続情報
const url = process.env.VUE_APP_API_ORIGIN;
const username = process.env.VUE_APP_API_USER;
const password = process.env.VUE_APP_API_PASS;
const timeout = 10000;

/*-- 2026.09.15 V2.2.2 AI MOD START チケット#14484 axiosは`auth`にオブジェクトを渡すと中身が
     undefinedでも無条件にAuthorization: Basicヘッダーを付与する仕様のため、VUE_APP_API_USER
     未設定時（現状の全環境）でも常にBasic認証ヘッダーが送信されていた。このヘッダーはリクエスト
     インターセプター（下記）がセットするAuthorization: Bearer <JWT>をアダプタ内部で後から
     上書きしてしまうため、$api経由のリクエストは実際にはJWTトークンがサーバーに届いていなかった
     （フェーズ3でトークン検証を必須化した際に軒並み401になる不具合の温床だったため修正） --*/
// インスタンス生成
// const instance = axios.create({
//   baseURL: url,
//   auth: { username: username, password: password },
//   timeout: timeout,
// });
const instance = axios.create({
  baseURL: url,
  ...(username ? { auth: { username: username, password: password } } : {}),
  timeout: timeout,
});
/*-- 2026.09.15 V2.2.2 AI MOD END --*/

/*-- 2026.09.08 V2.2.1 AI ADD START チケット#14484 全API認証導入フェーズ1、トークン送信対応
     （サーバー側はまだ検証を強制しない緩い状態） --*/
instance.interceptors.request.use(function (config) {
  const token = store.state.token;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
/*-- 2026.09.08 V2.2.1 AI ADD END --*/

// エラーハンドリング
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // let errorCode = "詳細：";
    // const isTimeout = error.code === "ECONNABORTED";
    // if (isTimeout) {
    //   errorCode += "Timeout (" + apiTimeout + "ms)";
    // } else if (!error.response) {
    //   switch (error.response?.status) {
    //     case 400:
    //       errorCode += "400 Bad Request";
    //       break;
    //     case 401:
    //       errorCode += "401 Unauthorized";
    //       break;
    //     case 403:
    //       errorCode += "403 Forbidden";
    //       break;
    //     case 404:
    //       errorCode += "404 Not Found";
    //       break;
    //     case 405:
    //       errorCode += "405 Method Not Allowed";
    //       break;
    //     case 500:
    //       errorCode += "500 Internal Server Error";
    //       break;
    //     case 501:
    //       errorCode += "501 Not Implemented";
    //       break;
    //     case 502:
    //       errorCode += "502 Bad Gateway";
    //       break;
    //     case 503:
    //       errorCode += "503 Service Unavailable";
    //       break;
    //     case 504:
    //       errorCode += "504 Gateway Timeout";
    //       break;
    //     default:
    //       errorCode = error;
    //       break;
    //   }
    // }
    // console.log(error);
    // return Promise.reject(errorCode);
    /*-- 2026.09.08 V2.2.1 AI ADD START チケット#14484 フェーズ3（トークン必須化）でサーバーが401を
         返すようになった際、利用者に生のエラーを見せず自動的にログアウト・ログイン画面へ戻す。
         現時点ではどのルートもトークンを検証していないため401は返らず、実質的にまだ発火しない --*/
    if (error.response && error.response.status === 401) {
      /*-- 2026.09.10 V2.2.1 AI MOD START チケット#14484 何も表示せずいきなりログイン画面に
           戻ると利用者が状況を理解できないため、リダイレクト前にメッセージを表示するよう修正 --*/
      if (router.app && router.app.snackbar) {
        router.app.snackbar.showMessage("セッションの有効期限が切れました。再度ログインしてください。", "warning");
      }
      /*-- 2026.09.10 V2.2.1 AI MOD END --*/
      const kigyoCd = store.state.kigyoCode;
      store.commit("reset");
      router.push({ name: "UserLogin", params: { kigyoCd } }).catch(() => {});
    }
    /*-- 2026.09.08 V2.2.1 AI ADD END --*/
    return Promise.reject(error);
  }
);

// リトライ
axiosRetry(instance, {
  retries: 1, // 回数
  retryCondition: () => true, // 条件（true:4XX/5XXエラー時, false:5XXエラー時のみ）
  retryDelay: () => {
    return 500; // 遅延（ミリ秒）
  },
});

export default instance;
